// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "dl[data-v-dd834e76]{columns:auto 4;gap:1.5rem}dl>div[data-v-dd834e76]{-webkit-column-break-inside:avoid;page-break-inside:avoid;break-inside:avoid;margin-bottom:1rem}@media(max-width: 767.98px){dl[data-v-dd834e76]{columns:auto 2}}@media(max-width: 575.98px){dl[data-v-dd834e76]{columns:auto 1}}.element-details[data-v-dd834e76] dt{font-weight:normal}.element-details[data-v-dd834e76] dd{break-before:avoid;font-weight:bold}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
